import { Injectable } from '@angular/core';
import { ClientBaseApiService } from 'src/app/core/api/client-base-api.service';
import { HttpRequestTypes } from 'src/app/core/models/enums/http-request-types';
import { environment } from 'src/environments/environment';
import { ErrorLogResponse, ErrorLogRequest, Thread, ProblemList, ThreadMessage, DeviceList } from '../models/profile';

@Injectable({
  providedIn: 'root'
})
export class QuestionErrorService {


  constructor(private clientApiService: ClientBaseApiService) { }

  getErrorLogs() {
    let url = environment.baseApiUrl + "v2/api/device/errorlogs/list";
    return this.clientApiService.baseApiCall<ErrorLogResponse[]>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  saveErrorLog(payload) {
    let url = environment.baseApiUrl + "v2/api/device/errorlogs/save";
    return this.clientApiService.baseApiCall<any>({ url: url, payload: payload, requestType: HttpRequestTypes.POST });
  }

  getDeviceList() {
    let url = environment.baseApiUrl + "v2/api/device/list/by/userId";
    return this.clientApiService.baseApiCall<DeviceList[]>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  getQuestions() {
    let url = environment.baseApiUrl + "v2/api/farmerproblems/list";
    return this.clientApiService.baseApiCall<ProblemList[]>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  saveQuestion(payload) {
    let url = environment.baseApiUrl + "v2/api/farmerproblems/save";
    return this.clientApiService.baseApiCall<any>({ url: url, payload: payload, requestType: HttpRequestTypes.POST });
  }
  saveQuestionThread(payload) {
    let url = environment.baseApiUrl + "v2/api/farmerproblems/thread/message/client";
    return this.clientApiService.baseApiCall<any>({ url: url, payload: payload, requestType: HttpRequestTypes.POST });
  }

  getQuestionByThread(problemId) {
    let url = environment.baseApiUrl + "v2/api/farmerproblems/thread/detail/by/problemId?problemId=" + problemId;
    return this.clientApiService.baseApiCall<ThreadMessage>({ url: url, payload: {}, requestType: HttpRequestTypes.GET });
  }

  stopThread(id) {
    let url = environment.baseApiUrl + "v2/api/farmerproblems/thread/stop/" + id;
    return this.clientApiService.baseApiCall<any>({ url: url, payload: {}, requestType: HttpRequestTypes.POST });
  }
}
